export const PUBLIC_PATHS = {
  // client
  CLIENT_LOGIN: "/client/auth/login",
  CLIENT_UPDATE_PASSWORD: "/client/auth/update-password",
  CLIENT_FORGOT_PASSWORD: "/client/auth/forgot-password",

  // admin
  ADMIN_LOGIN: "/admin/auth/login",
  ADMIN_UPDATE_PASSWORD: "/admin/auth/update-password",
  ADMIN_FORGOT_PASSWORD: "/admin/auth/forgot-password",
};

export const PRIVATE_PATHS = {
  // admin
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_ALL_TRANSACTIONS: "/admin/transactions/all",
  ADMIN_PRE_APPROVALS: "/admin/transactions/pre-approvals",
  ADMIN_KYC: "/admin/clients/kyc",
  ADMIN_STAFFS: "/admin/settings/staffs",
  ADMIN_DEPTS: "/admin/settings/roles/departments",
  ADMIN_PERMISSIONS: "/admin/settings/roles/permissions",
  ADMIN_ROLES: "/admin/settings/roles/system-roles",
  ADMIN_ROLE: "/admin/settings/roles/system-roles/:id",
  ADMIN_ADD_ROLE: "/admin/settings/roles/system-roles/create",
  ADMIN_ISSUES: "/admin/settings/issues",
  ADMIN_COUNTRIES: "/admin/settings/extras/countries",
  ADMIN_STATES: "/admin/ettings/extras/states",
  ADMIN_TRADE_DYNAMICS: "/admin/settings/extras/trade-dynamics",
  ADMIN_CURRENCIES: "/admin/settings/extras/currencies",
  ADMIN_LGAS: "/admin/settings/extras/lgas",
  ADMIN_ACC_AUDITS: "/admin/audits/account-mgt",
  ADMIN_TRANS_AUDITS: "/admin/audits/transaction-mgt",
  ADMIN_TRANS_AUDIT: "/admin/audits/transaction-mgt/:id",

  //ADMIN_KYB
  ADMIN_NEW_CLIENTS: "/admin/clients/new-clients",
  ADMIN_NEW_CLIENTS_STEP_1: "/admin/clients/new-clients/kyc/step-1/:id",
  ADMIN_NEW_CLIENTS_STEP_2: "/admin/clients/new-clients/kyc/step-2/:id",
  ADMIN_NEW_CLIENTS_STEP_3: "/admin/clients/new-clients/kyc/step-3/:id",
  ADMIN_NEW_CLIENTS_STEP_4: "/admin/clients/new-clients/kyc/step-4/:id",
  ADMIN_NEW_CLIENTS_STEP_5: "/admin/clients/new-clients/kyc/step-5/:id",
  ADMIN_KYC_STEP_1: "/admin/clients/kyc/step-1/:id",
  ADMIN_KYC_STEP_2: "/admin/clients/kyc/step-2/:id",
  ADMIN_KYC_STEP_3: "/admin/clients/kyc/step-3/:id",
  ADMIN_KYC_STEP_4: "/admin/clients/kyc/step-4/:id",
  ADMIN_KYC_STEP_5: "/admin/clients/kyc/step-5/:id",

  // CLIENT
  CLIENT_DASHBOARD: "/client/dashboard",
  CLIENT_STEP_1: "/client/kyc-verification/step-1",
  CLIENT_STEP_2: "/client/kyc-verification/step-2",
  CLIENT_STEP_3: "/client/kyc-verification/step-3",
  CLIENT_STEP_4: "/client/kyc-verification/step-4",
  CLIENT_STEP_5: "/client/kyc-verification/step-5",
  CLIENT_AUTH_STEP_1: "/client/dashboard/business-information",
  CLIENT_AUTH_STEP_2: "/client/dashboard/finance-details",
  CLIENT_AUTH_STEP_3: "/client/dashboard/risk-assessments",
  CLIENT_AUTH_STEP_4: "/client/dashboard/documents-upload-1",
  CLIENT_AUTH_STEP_5: "/client/dashboard/documents-upload-2",
};
